<template>
    <div class="info-tags">
        <div class="info-tags__total">
            <InfoTag
                icon="icon-checkmark"
                :text="$t('InfoTag.completedStudies')"
                :amount="totalCompletedCourses"
            />
            <InfoTag icon="icon-clock" :text="$t('InfoTag.totalDuration')" :amount="totalCourseDuration"/>
        </div>
        <div class="info-tags__authorizations">
            <span class="info-tags__authorizations-title">{{ $t('AuthorizationHours.title' )}}:</span>
            <TotemTag
                v-for="(authorizationHours, index) in filteredAuthorizationHours"
                :label="authorizationHours.label"
                :name="authorizationHours.duration"
                :clear="false"
            />
        </div>
    </div>
</template>

<script>
    import InfoTag from 'components/user/shared/InfoTag'
    import convertMinutesToHours from 'components/shared/mixins/convertMinutesToHours'

    export default {
        name: 'completed-info-tags',
        components: {
            InfoTag
        },
        mixins: [convertMinutesToHours],
        props: {
            filteredCourseList: Object
        },
        computed: {
            totalCompletedCourses () {
                return this.filteredCourseList.courses.length + this.filteredCourseList.learningPaths.length
            },
            totalCourseDuration () {
                return this.convertMinutesToHours(
                    this.filteredCourseList.courses.reduce((acc, course) => acc + course.certificate.duration, 0))
            },
            filteredAuthorizationHours () {
                let sumOfAuthorizationItemsByLabel = this.getAuthorizationCreditItems().reduce((sumByLabel, authorizationItem) => {
                    const { label, duration } = authorizationItem
                    if (!sumByLabel[label]) {
                        sumByLabel[label] = 0
                    }
                    sumByLabel[label] += duration
                    return sumByLabel
                }, {})
                return Object.entries(sumOfAuthorizationItemsByLabel).map(([label, duration]) => {
                    if (!Number.isInteger(duration)) {
                        duration = duration.toFixed(2)
                    }
                    return { label, duration }
                })
            }
        },
        methods: {
            getAuthorizationCreditItems () {
                let coursesWithAuthorization = []

                if (this.filteredCourseList !== undefined && this.filteredCourseList !== null && this.filteredCourseList.courses.length > 0) {
                    this.filteredCourseList.courses.forEach((course) => {
                        course.certificate.durations.forEach(durationItem => {
                            coursesWithAuthorization.push({
                                label: durationItem.category,
                                duration: +durationItem.credits,
                                id: course.courseId
                            })
                        })
                    })
                }
                return coursesWithAuthorization
            },
            displayFormattedAuthorizationHoursInfo (authorizationHours) {
                return this.$t('CompletedCourses.total_number_of_authorization_hours_for') + ' ' + authorizationHours.label + ': ' + authorizationHours.duration
            }
        }
    }
</script>

<style lang="scss" scoped>
.info-tags {
    display: flex;
    flex-direction: column;
    gap: 20px;
    flex-wrap: wrap;

    [class*="mobile_sm"] & {
        gap: 10px;
    }

    &__total {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 10px;
    }

    &__authorizations {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }

    &__authorizations-title {
        margin: 0 10px 0 0;
    }
}
</style>
